<template>
  <div class="date-bar" title="Dev/testing: as-of date for wallboard APIs">
    <span class="date-bar__label">As-of date</span>
    <input
      v-model="localDate"
      class="date-bar__input"
      type="date"
      @change="apply"
    />
    <button type="button" class="date-bar__btn" @click="apply">Apply</button>
    <button type="button" class="date-bar__btn date-bar__btn--ghost" @click="useToday">
      Today
    </button>
    <button
      type="button"
      class="date-bar__btn date-bar__btn--ghost"
      @click="useDefault"
    >
      −1 month
    </button>
    <span v-if="isHistorical" class="date-bar__hint">historical · SSE off</span>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  amsterdamToday,
  defaultWallboardDate,
  isHistoricalWallboardDate,
} from "../shared/wallboardDate";

export default {
  name: "DateBar",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const localDate = ref(route.query.date || defaultWallboardDate());

    watch(
      () => route.query.date,
      (value) => {
        if (value && value !== localDate.value) {
          localDate.value = value;
        }
      }
    );

    const isHistorical = computed(() =>
      isHistoricalWallboardDate(localDate.value)
    );

    function apply() {
      if (!localDate.value) return;
      router.replace({
        query: { ...route.query, date: localDate.value },
      });
    }

    function useToday() {
      localDate.value = amsterdamToday();
      apply();
    }

    function useDefault() {
      localDate.value = defaultWallboardDate();
      apply();
    }

    return {
      localDate,
      isHistorical,
      apply,
      useToday,
      useDefault,
    };
  },
};
</script>

<style scoped>
.date-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.45rem 0.75rem;
  background: rgba(15, 23, 42, 0.92);
  color: #e2e8f0;
  font-family: "IBM Plex Sans", "Segoe UI", sans-serif;
  font-size: 0.8rem;
  border-top: 1px solid #334155;
}

.date-bar > * {
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
}

.date-bar__label {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  font-size: 0.7rem;
}

.date-bar__input {
  border: 1px solid #475569;
  border-radius: 4px;
  background: #0f172a;
  color: #f8fafc;
  padding: 0.2rem 0.4rem;
  font: inherit;
}

.date-bar__btn {
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.55rem;
  background: #0d9488;
  color: #042f2e;
  font-weight: 600;
  font: inherit;
  cursor: pointer;
}

.date-bar__btn--ghost {
  background: transparent;
  color: #cbd5e1;
  border: 1px solid #475569;
}

.date-bar__hint {
  margin-left: auto;
  color: #fbbf24;
  font-size: 0.72rem;
}
</style>
